import { render } from "./Indicators.vue?vue&type=template&id=2954adba"
import script from "./Indicators.vue?vue&type=script&lang=js"
export * from "./Indicators.vue?vue&type=script&lang=js"

import "./Indicators.vue?vue&type=style&index=0&id=2954adba&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__